import { motion } from "framer-motion";
import { ArrowDown, Sparkles } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a2c28dda-b6c6-423c-b58a-acb578417488/images/8063ca8834b07f933e42dc387abdfa497177536cd325ca8f94240777583199b3.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-36 md:pt-44 pb-20 md:pb-32 overflow-hidden fis-grain"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end relative">
        <div className="lg:col-span-7 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="fis-chip mb-8"
            data-testid="hero-chip"
          >
            <span className="dot" />
            FIS — Intelligence, shipped.
          </motion.div>

          <h1
            data-testid="hero-headline"
            className="font-display text-[14vw] md:text-[9vw] lg:text-[7.2rem] xl:text-[8.5rem]"
          >
            Talent.
            <br />
            Software.
            <br />
            <span className="text-[color:var(--fis-accent)]">
              Intelligence
              <span className="fis-cursor">_</span>
            </span>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-8 max-w-xl text-lg leading-relaxed text-[color:var(--fis-ink-soft)]"
          >
            Frontline Intelligence System is an operating partner for ambitious
            teams — we recruit high-caliber talent, ship production-grade
            software, build AI chatbots that actually convert, and design
            websites that move the needle.
          </motion.p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="fis-btn fis-btn-primary"
            >
              Start a project
            </a>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              className="fis-btn fis-btn-outline"
            >
              Explore services <ArrowDown className="w-4 h-4" />
            </a>
          </div>

          <div className="mt-16 flex items-center gap-8">
            <div>
              <div className="font-display text-3xl">120+</div>
              <div className="font-mono-label mt-1">Projects shipped</div>
            </div>
            <div className="w-px h-10 bg-black/10" />
            <div>
              <div className="font-display text-3xl">40+</div>
              <div className="font-mono-label mt-1">Enterprise clients</div>
            </div>
            <div className="w-px h-10 bg-black/10 hidden sm:block" />
            <div className="hidden sm:block">
              <div className="font-display text-3xl">9</div>
              <div className="font-mono-label mt-1">Time zones</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <motion.div
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative aspect-square w-full max-w-md ml-auto"
          >
            <img
              src={HERO_IMG}
              alt="FIS abstract"
              className="w-full h-full object-cover"
              data-testid="hero-image"
            />
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("fis:open-chatbot"))}
              data-testid="hero-ai-concierge"
              className="absolute -bottom-6 -left-6 bg-white border fis-hairline p-4 flex items-center gap-3 text-left hover:border-[color:var(--fis-accent)] transition-colors cursor-pointer"
            >
              <Sparkles className="w-4 h-4 text-[color:var(--fis-accent)]" />
              <div>
                <div className="font-mono-label">AI concierge · Live</div>
                <div className="text-sm font-medium">
                  Ask our bot anything →
                </div>
              </div>
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
